export default (theme: Object) => ({
  colorDot: {
    height: 20,
    width: 20,
    marginRight: 8,
    borderRadius: 4,
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    },
  },
  hidden: {
    display: 'none',
  },
});
